import React, { useEffect } from 'react';

import { EMessageDirection, EMessageType, IIncommingTextInput, IMessageComplete, IOutcommingTextInput, useMessages } from '../../../hooks/Messages';
import { textPreprocessor } from './common';
import MessageWrapper from './MessageWrapper';

export interface IOutcommingTextInputProps extends IOutcommingTextInput {
    message: IMessageComplete
    scrollToBottom: () => void
}

function OutcommingTextInput({ text, message }: IOutcommingTextInputProps) {
    const { push } = useMessages();

    useEffect(
        () => {
            push({
                direction: EMessageDirection.Incomming,
                type: EMessageType.TextInput,
                payload: {
                    qestion: text
                } as IIncommingTextInput
            });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return (
        <MessageWrapper direction={message.direction}>
            <span>{textPreprocessor(text)}</span>
        </MessageWrapper>
    );
}

export default OutcommingTextInput;
